module.exports = __webpack_public_path__ + "img/note.0bcc4ddc.svg";